export const PRODUCT_DETAIL_PRICE_CALENDAR_SHOWN = 'PRODUCT_DETAIL_PRICE_CALENDAR_SHOWN';
export const PRODUCT_DETAIL_PRICE_CALENDAR_SHOWN_VERSION = '1.0';

export type PriceCalendarShownPayload = {
  productDetailKey: string;
  expanded: boolean;
};

export type PriceCalendarShownParams = {
  productDetailKey: string;
  expanded: boolean | undefined;
};

export const createPriceCalendarShownPayload = ({
  productDetailKey,
  expanded,
}: PriceCalendarShownParams): PriceCalendarShownPayload => ({
  productDetailKey,
  expanded: expanded || false,
});
